import { apiClient } from '@/shared/api';

import type {
  PromotionAuditPage,
  PromotionRequest,
  PromotionResponse,
  PromotionStatsResponse,
  PromotionStatus,
  PromotionSummaryPage,
} from '../model/types';

const BASE = '/api/v1/catalog/promo/promotions';

export interface ListPromotionsParams {
  status?: PromotionStatus;
  page?: number;
  size?: number;
}

export const listPromotions = async (
  params: ListPromotionsParams = {},
): Promise<PromotionSummaryPage> => (await apiClient.get<PromotionSummaryPage>(BASE, { params })).data;

export const createPromotion = async (body: PromotionRequest): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(BASE, body)).data;

export const getPromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.get<PromotionResponse>(`${BASE}/${promotionId}`)).data;

export const updatePromotion = async (
  promotionId: string,
  body: PromotionRequest,
): Promise<PromotionResponse> =>
  (await apiClient.put<PromotionResponse>(`${BASE}/${promotionId}`, body)).data;

export const submitPromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/submit`)).data;

export const approvePromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/approve`)).data;

export const rejectPromotion = async (
  promotionId: string,
  reason?: string,
): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/reject`, { reason })).data;

export const activatePromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/activate`)).data;

export const pausePromotion = async (
  promotionId: string,
  reason?: string,
): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/pause`, { reason })).data;

export const endPromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/end`)).data;

export const archivePromotion = async (promotionId: string): Promise<PromotionResponse> =>
  (await apiClient.post<PromotionResponse>(`${BASE}/${promotionId}/archive`)).data;

export interface ListPromotionAuditParams {
  page?: number;
  size?: number;
}

export const listPromotionAudit = async (
  promotionId: string,
  params: ListPromotionAuditParams = {},
): Promise<PromotionAuditPage> =>
  (await apiClient.get<PromotionAuditPage>(`${BASE}/${promotionId}/audit`, { params })).data;

export const getPromotionStats = async (promotionId: string): Promise<PromotionStatsResponse> =>
  (await apiClient.get<PromotionStatsResponse>(`${BASE}/${promotionId}/stats`)).data;
